import { MemberBulkButtonComponents } from "@components/common/faro-table/faro-table-types";
import { BaseGroupDetailsProps } from "@custom-types/group-types";
import { useHasUserValidRoleGroupLevel } from "@hooks/access-control/use-has-user-valid-role-group-level";
import { InviteMemberToGroup } from "@pages/group-details/invite-member-to-group";
import { useGroupMembersMenuOptionsMobile } from "@pages/group-details/use-group-members-menu-options-mobile";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";
import { sortMembers } from "@utils/member-utils";
import { MembersSortBy } from "@custom-types/member-types";

interface Props extends Partial<BaseGroupDetailsProps> {
  /** List of all the bulk actions and callbacks */
  bulkActionButtons: MemberBulkButtonComponents;

  /** Whether the data for showing a table is loading or not */
  isLoading: boolean;

  /** Current sort by value from the sort dropdown */
  sortBy: MembersSortBy;
}

/**
 * Mobile-specific view for members list.
 * Renders a virtualized list of members for the groups with selection, menu options, and bulk actions.
 */
export function GroupMembersMobileView({
  group,
  bulkActionButtons,
  isLoading,
  sortBy,
}: Props): JSX.Element {
  const menuItems = useGroupMembersMenuOptionsMobile();
  const { canInviteUsersToGroup } = useHasUserValidRoleGroupLevel({
    selectedGroup: group ?? null,
  });

  const sortedMembers = sortMembers(group?.members ?? [], sortBy);

  return (
    <MemberMobileList
      members={sortedMembers}
      isLoading={isLoading}
      bulkActionButtons={bulkActionButtons}
      tableSubject="group"
      menuItems={menuItems}
      renderFooterExtra={() =>
        group && <InviteMemberToGroup group={group} buttonVariant="filled" />
      }
      shouldShowFooterExtra={canInviteUsersToGroup}
      group={group}
      sortBy={sortBy}
    />
  );
}
